import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { makeHeadData } from 'lib/commonLib';
import { paramConverter } from 'modules/common';
import { rankTableData } from 'lib/api/media';

import BasicTable from 'components/molecules/MbBasicTable';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const useStyles = makeStyles((theme) => ({
  title: {
    flex: '0 0 auto',
    marginBottom: 10,
  },
}));

const MediaRankTable = ({ params }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const tableHead = {
    headList: [
      {
        id: 'MEDIA_NAME',
        label: t('매체명'),
        orderFlag: false,
        type: null,
        format: '@',
      },
      {
        id: 'PAR_EPRS_CNT',
        label: t('노출수'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CLICK_CNT',
        label: t('클릭수'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CLICK_RATE',
        label: t('클릭율'),
        orderFlag: false,
        type: 'number',
        format: '0.00%',
      },
      {
        id: 'ADVRTS_AMT',
        label: t('지출금액'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'SESSION_ORDER_AMT',
        label: t('세션매출'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'SESSION_ROAS',
        label: t('세션ROAS'),
        orderFlag: false,
        type: 'number',
        format: '0.0%',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  };

  const initTableList = [];
  const [tableList, setTableList] = useState(initTableList);
  const initLoading = {
    table: true,
  };
  const [loading, setLoading] = useState(initLoading);

  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  useEffect(() => {
    getData(); // eslint-disable-next-line
  }, [params]);

  const getData = () => {
    setLoading(initLoading);
    setTableList(initTableList);
    rankTableData({ ...paramConverter(params) })
      .then((response) => {
        const { data } = response.data;
        setTableList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...snackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setLoading({
          ...loading,
          table: false,
        });
      });
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
      message: '',
    });
  };

  return (
    <>
      <div className={classes.title}>
        <Typography variant="h6">
          {params.month + t('월 상위 TOP10 (어제기준)')}
        </Typography>
      </div>
      <BasicTable
        sort={tableHead.sort}
        order={tableHead.order}
        list={tableList}
        headCells={makeHeadData(tableHead.headList)}
        loading={loading.table}
      />
      <SnackbarWrap
        open={snackbar.open}
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleSnackBarClose}
      />
    </>
  );
};

export default MediaRankTable;
